import { render, staticRenderFns } from "./productService.vue?vue&type=template&id=20a9c739&scoped=true"
import script from "./productService.vue?vue&type=script&lang=js"
export * from "./productService.vue?vue&type=script&lang=js"
import style0 from "./productService.vue?vue&type=style&index=0&id=20a9c739&prod&lang=css"
import style1 from "./productService.vue?vue&type=style&index=1&id=20a9c739&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a9c739",
  null
  
)

export default component.exports